import ToggleRow from './ToggleRow'
import type { FilterOption, FilterToggleGroup } from 'lib/dealhunt/types'

interface TogglesControlProps {
  group: FilterToggleGroup
  onOption: (option: FilterOption, on: boolean) => void
}

/** Switch rows with counts (boolean specs and config-defined bundles). */
const TogglesControl: React.VFC<TogglesControlProps> = ({ group, onOption }) => (
  <div>
    {group.options.map(opt => (
      <ToggleRow
        key={`${opt.param.key}:${opt.value}`}
        label={opt.label}
        count={opt.count}
        selected={opt.selected}
        onClick={() => onOption(opt, !opt.selected)}
      />
    ))}
  </div>
)

export default TogglesControl
